<template>
  <div id="app">
    <transition name="fade">
    <router-view />
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  data() {
    return {};
  },
  computed: {
    ...mapState({}),
  },
  watch: {
    $route: {
      handler(to, from) {
        // console.log(to)
      },
      deep: true,
    },
  },
  methods: {},
};
</script>

<style>
#app {
  /*background:white;*/
  /* display:table-cell; */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.6;
}
</style>
